module.exports = __webpack_public_path__ + "static/img/jieshao2.8914a6ea.png";